import { render, staticRenderFns } from "./MemberNode.vue?vue&type=template&id=c20e04ea&scoped=true&"
import script from "./MemberNode.vue?vue&type=script&lang=js&"
export * from "./MemberNode.vue?vue&type=script&lang=js&"
import style0 from "./MemberNode.vue?vue&type=style&index=0&id=c20e04ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20e04ea",
  null
  
)

export default component.exports